export default[
    {
        path: '/comissionador/cadastro',
        name: 'cadastro', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    // {
    //     path: '/comissionador/lista',
    //     name: 'lista', 
    //     component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    // },
    // {
    //     path: '/comissionador/editar/:id',
    //     name: 'lista', 
    //     component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    // },
]